import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Tap_Assistant_Icon.png")